// extracted by mini-css-extract-plugin
export default {"input-increment-container":"style_input-increment-container__I0VpA","input-incremental":"style_input-incremental__shkAm"};